import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import EmptyState from './empty-state';
import GiftCardCategoriesCard from 'components/gift-card-categories-card';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { GiftCardCategoryType } from 'utils/types';
import { Link } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';

const Categories = () => {
  const [loading, setLoading] = useState(false);
  const [giftCardCategories, setGiftCardCategories] = useState<GiftCardCategoryType[]>([]);
  const { permissions } = useDashboardContext();

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await apiService.get(`vouchers/voucher-categories`, {
        isInternal: true,
        baseURL: process.env.REACT_APP_ORDER_API
      });
      if (res?.data) {
        setGiftCardCategories(res?.data);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const canAccessGiftCards = permissions.canAccessGiftCards;
  if (!canAccessGiftCards) return <AccessDenied />;
  return (
    <div className='max-w-[885px]'>
      <PageHeaderText
        title='Manage Giftcard Categories'
        description='Create and manage gift card categories'>
        <Link
          to={ROUTE_KEYS.CREATE_GIFTCARD_CATEGORY}
          className='cursor-pointer text-sm font-medium text-[#E60A2B] w-fit'>
          + Add new
        </Link>
      </PageHeaderText>
      {loading ? (
        <p className='flex justify-center items-center min-h-full mt-20'>Loading...</p>
      ) : giftCardCategories.length === 0 ? (
        <EmptyState />
      ) : (
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 my-7'>
          {giftCardCategories.map((item, index) => (
            <GiftCardCategoriesCard key={index} data={item} refetch={fetchCategories} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Categories;
